import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dialog } from '@mui/material';

import { Title } from './Title';

import { selectEventDialogData } from 'main/store/schedule/selectors';
import { actions } from 'main/store/schedule/reducer';
import { Content } from './Content';
import { Actions } from './Actions';

export const EventFormDialog = () => {
    const dispatch = useDispatch();
    const dialogData = useSelector(selectEventDialogData);

    const handleClose = useCallback(() => {
        dispatch(actions.closeEventDialog());
    }, [dispatch]);

    return dialogData && (
        <Dialog open={true} onClose={handleClose}>
            <Title />
            <Content />
            <Actions onClose={handleClose} />
        </Dialog>
    )
}
